import { useRef } from "react";

const SENSITIVE = ["token", "code", "state", "key", "secret", "access_token", "refresh_token", "invite"];
let last = { path: null, taken: {} };

// Reads secret-bearing query params once, then removes them from the address bar (no new history entry).
export function takeSensitiveParams() {
  const url = new URL(window.location.href);
  const taken = {};
  SENSITIVE.forEach((k) => {
    if (url.searchParams.has(k)) {
      taken[k] = url.searchParams.get(k);
      url.searchParams.delete(k);
    }
  });
  if (Object.keys(taken).length) {
    window.history.replaceState(window.history.state, "", url.pathname + url.search + url.hash);
    last = { path: url.pathname, taken };
    return taken;
  }
  if (last.path === url.pathname) {  // StrictMode double render on the same page; reuse once
    const reused = last.taken;
    last = { path: null, taken: {} };
    return reused;
  }
  return {};
}

export function useCapturedParams() {
  const ref = useRef(null);
  if (ref.current === null) ref.current = takeSensitiveParams();
  return ref.current;
}
